import React from 'react';
import { PageHeaderSection } from '../../../components/common/PageHeadSection';
import { useTranslation } from 'react-i18next';
import { Collapse } from 'antd';

const { Panel } = Collapse;

const FAQ = () => {
    const { t } = useTranslation();
    const faqData = [
        { key: '1', title: t("help.faqData.forgotPasswordTitle"), content: t("help.faqData.forgotPasswordContent") },
        { key: '2', title: t("help.faqData.pendingReservationTitle"), content: t("help.faqData.pendingReservationContent") },
        { key: '3', title: t("help.faqData.confirmedReservationTitle"), content: t("help.faqData.confirmedReservationContent") },
        { key: '4', title: t("help.faqData.cancelReservationTitle"), content: t("help.faqData.cancelReservationContent") },
        { key: '5', title: t("help.faqData.confirmationIssueTitle"), content: t("help.faqData.confirmationIssueContent") },
        { key: '6', title: t("help.faqData.entryListTitle"), content: t("help.faqData.entryListContent") },
        { key: '7', title: t("help.faqData.stopFreeSaleTitle"), content: t("help.faqData.stopFreeSaleContent") },
        { key: '8', title: t("help.faqData.actionSubmissionTitle"), content: t("help.faqData.actionSubmissionContent") },
        { key: '9', title: t("help.faqData.hotel2SejourPlusMembershipTitle"), content: t("help.faqData.hotel2SejourPlusMembershipContent") },
        { key: '10', title: t("help.faqData.createNewUserTitle"), content: t("help.faqData.createNewUserContent") },
        { key: '11', title: t("help.faqData.agencyConnectionQuestion"), content: t("help.faqData.agencyConnectionAnswer") },
        { key: '12', title: t("help.faqData.paximumIdQuestion"), content: t("help.faqData.paximumIdAnswer") }
    ];

    return (
        <div className="nk-content">
            <div className="container-fluid">
                <div className="nk-content-inner">
                    <div className="nk-content-body">
                        <PageHeaderSection pageTitle={t("help.faq")} />
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-body">
                                    <Collapse accordion>
                                        {faqData.map(item => (
                                            <Panel header={item.title} key={item.key}>
                                                <p>{item.content}</p>
                                            </Panel>
                                        ))}
                                    </Collapse>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FAQ;
